<template>
  <div v-if="loading">
      <PolygonLoader :centered="false" :size="40" :width="3" />
    </div>
  <div v-else-if="error">
    <p>{{ $t('messages.messageLoadError') }}</p>
  </div>
  <div
    v-else
    class="quick-chat-container"
  >
    <PolygonMessageDisplay
      :messages="messages"
    />
    <PolygonMentionList
      :mentionMode="mentionMode"
      :selectedMentionIndex="selectedMentionIndex"
      />
    <PolygonMessageManager
    ref="messageManager"
      :mentionMode="mentionMode"
      :selectedMentionIndex="selectedMentionIndex"
      :mentions="mentions"
      />
      <p class="text--disabled text-caption font-italic pt-2">{{ $t('messages.mentionHint') }}</p>
  </div>
</template>

<script>
import '@/assets/styles/libs/vue-quick-chat.css'
import messageRepository from '@/core/repository/message-repository'

export default {
  data() {
    return {
      error: false,
      loading: true,
      selectedMentionIndex: 0,
      mentionMode: false,
      mentions: [],
      messages: []
    }
  },
  mounted() {
    this.subscribe('jumpOutMentionMode', this.jumpOutMentionMode)
    this.subscribe('selectedMention', this.handleSelectedMention)
    this.subscribe('changeSelectedMentionIndex', this.handleChangeSelectedMentionIndex)
    this.subscribe('messageSent', this.handleMessageSent)
    this.subscribe('goToMentionMode', () => { this.mentionMode = true })
  },
  async activated() {
    this.loading = true
    this.error = false
    await this.getMessages()
    this.loading = false
  },
  methods: {
    async getMessages() {
      try{
        const messages = await messageRepository.getMessages(this.errandId)
        this.messages = messages
        this.scrollToBottom()
      } catch(error) {
        this.error = true
      }
    },
    async handleMessageSent() {
      this.mentions = []
      await this.getMessages()
    },
    scrollToBottom() {
      setTimeout(() => {
        var chatWindow = document.querySelector('.container-message-display')
        chatWindow.scrollTop = chatWindow.scrollHeight
      }, 0)
    },
    handleSelectedMention(selectedMention) {
      if(selectedMention) {
        this.mentions.push(selectedMention.email)
        this.$refs.messageManager.$refs.userInput.textContent += selectedMention.email
        this.jumpOutMentionMode()
      }
    },
    handleChangeSelectedMentionIndex(change) {
      if(this.selectedMentionIndex + change >= 0 && this.selectedMentionIndex + change < this.errandMembers.chatMentionParticipants.length) {
        this.selectedMentionIndex += change
      }
    },
    jumpOutMentionMode() {
      this.mentionMode = false
      this.selectedMentionIndex = 0
      this.setEndOfContenteditable()
    },
    setEndOfContenteditable() {
      const contentEditableElement = this.$refs.messageManager.$refs.userInput
      let range, selection
      range = document.createRange()
      range.selectNodeContents(contentEditableElement)
      range.collapse(false)
      selection = window.getSelection()
      selection.removeAllRanges()
      selection.addRange(range)
    }
  }
}
</script>

<style lang="scss">
.quick-chat-container {
  display: flex;
  width: 100%;
  height: 100%;
  background-color: rgba(var(--color-subtle), 1);
  flex-direction: column;
  align-items: stretch;
  overflow: hidden;
}
</style>
